import React from 'react';

export default class Page10 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToMaintainMomentum');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Consider your role model</div>
                                            <p>Try and identify someone you know who you admire for their
                                                ability to see things through. Think
                                                about what it is you like about their approach and what works
                                                well for them. Then consider how
                                                you can adapt your style. This is the starting point for you to
                                                develop a plan to improve – see
                                                below.
                                            </p>
                                            <div className="border_subtitle">Look for opportunities to
                                                practise
                                            </div>
                                            <p>Watch out for opportunities in your current work or elsewhere to
                                                practise some of the tips and
                                                exercises that you have picked up from this tool.</p>
                                            <div className="border_subtitle">Write a development plan</div>
                                            <p>Use this tool to write out a personal, focused development
                                                plan.</p>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="uiheading"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToRaiseEnergyLevels')}
                                                        className="link_color task button-link-redirect">How to raise energy
                                                        levels</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToPrioritiseTasksReadyForAction')}
                                                        className="link_color task button-link-redirect">How to prioritise tasks
                                                        ready for action</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDirectPeople')}
                                                        className="link_color task button-link-redirect">How to direct people</div>
                                                    </li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToDeliverEveryTime')}
                                                        className="link_color task button-link-redirect">How to deliver every
                                                        time</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToCopeWithSetbacks')}
                                                        className="link_color task button-link-redirect">How to cope with
                                                        setbacks</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToEngageOthersToDeliver')}
                                                        className="link_color task button-link-redirect">How to engage others to
                                                        deliver</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToUseOptimismToAchieve')}
                                                        className="link_color task button-link-redirect">How to use optimism to
                                                        achieve</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToGetTheMostOutOfYourself')}
                                                        className="link_color task button-link-redirect">How to get the most out of
                                                        yourself.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>REFERENCES
                                            </div>


                                            <ol className="testclass">
                                                <li><p className="further_info_content">Buman, M., et al (2008).
                                                    Hitting the wall in the marathon: Phenomenological
                                                    characteristics and associations
                                                    with expectancy, gender, and running history.
                                                    <span
                                                        className="subtiltereg"> Psychology of Sport and Exercise,</span> 9,
                                                    177-190.</p></li>
                                                <li><p className="further_info_content">Ulmer, H. (1996).
                                                    Concept of an Extracellular Regulation of Muscular Metabolic
                                                    Rate During Heavy
                                                    Exercise in Humans by Psychophysiological Feedback.
                                                    <span className="subtiltereg"> Experientia, </span> 52,
                                                    416-420.</p></li>
                                                <li><p className="further_info_content"> Markman,
                                                    K. &amp; Guenther, C. (2007). Psychological momentum:
                                                    Intuitive physics and naive beliefs. <span
                                                        className="subtiltereg">Personality and Social Psychology Bulletin,</span> 33,
                                                    800-812.</p></li>
                                                <li><p className="further_info_content"> Lewin, K. (1961). <span
                                                    className="subtiltereg">Quasi-stationary social equilibria and the problem of permanent change.</span> 238-244.
                                                </p></li>
                                                <li><p className="further_info_content"> Mihaly Csikszentmihalyi
                                                    (1991). <span className="subtiltereg"> Flow.</span> SOS Free
                                                    Stock.</p></li>
                                                <li><p className="further_info_content"> Eastwood, J. D.,
                                                    Frischen, A., Fenske, M. J., &amp; Smilek, D. (2012). The
                                                    Unengaged Mind; Defining Boredom
                                                    in Terms of Attention. <span className="subtiltereg"> Perspectives on Psychological Science,</span> 7(5),
                                                    482-495.</p></li>
                                                <li><p className="further_info_content">Farmer,
                                                    R. &amp; Sundberg, N. (1986). Boredom proneness: The
                                                    development and correlates of a new scale. <span
                                                        className="subtiltereg">Journal of Personality Assessment, </span>50,
                                                    4-17.</p></li>
                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Task')}
                                                    className="button-next-previous-done task">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}